<template>
  <div>
    <!-- ⚠️ ทรงเดียวกับแท็บอื่นของ QA Settings (เช่น "เหตุผลของการให้คะแนน") —
         ข้อเท็จจริงที่ต้องรู้ก่อนแตะอะไรอยู่บนสุดเป็น v-alert · รายละเอียดยาว ๆ
         พับเก็บใน expansion panel ท้ายกล่อง 2 ไม่กระจายเป็นไอคอนเล็ก ๆ ทั่วหน้า -->
    <v-alert type="info" variant="tonal" density="compact" class="mb-3" icon="mdi-database-check-outline">
      <span class="text-body-2">
        {{ $t('qaPreDbNote') }}
      </span>
    </v-alert>

    <v-alert v-if="prechatEnabled" type="warning" variant="tonal" density="compact" class="mb-3"
      icon="mdi-robot-outline">
      <span class="text-body-2">
        {{ $t('qaPreBotOnBanner') }}
      </span>
    </v-alert>

    <!-- ══ 1 · บอท ═══════════════════════════════════════════════════════ -->
    <v-card class="qa-card-sm mb-3" variant="outlined">
      <v-card-title class="d-flex align-center py-3">
        <span class="text-subtitle-1">{{ $t('qaPreCard1Title') }}</span>
        <v-spacer />
        <v-chip size="small" :color="prechatEnabled ? 'primary' : ''" variant="tonal" label>
          {{ prechatEnabled ? $t('qaPreBotOn') : $t('qaPreBotOff') }}
        </v-chip>
      </v-card-title>
      <v-divider />
      <div class="pa-4">
        <div class="text-body-2 mb-1">
          {{ $t('qaPreBotOnDesc') }}
        </div>
        <div class="text-caption text-medium-emphasis mb-3">
          {{ $t('qaPreBotOffDesc') }}
        </div>

        <v-btn-toggle v-model="botMode" mandatory divided variant="outlined" density="comfortable">
          <v-btn value="inherit" size="small">
            {{ $t('qaPreInherit', { state: prechatFromAppSettings ? $t('qaPreOn') : $t('qaPreOff') }) }}
          </v-btn>
          <v-btn value="on" size="small" prepend-icon="mdi-robot">{{ $t('qaPreBtnOn') }}</v-btn>
          <v-btn value="off" size="small" prepend-icon="mdi-robot-off">{{ $t('qaPreBtnOff') }}</v-btn>
        </v-btn-toggle>

        <div class="text-caption text-medium-emphasis mt-2">
          {{ $t('qaPreInheritNote') }}
        </div>
      </div>
    </v-card>

    <!-- ══ 2 · สายงาน + คำที่จับ ═════════════════════════════════════════ -->
    <v-card class="qa-card-sm mb-3" variant="outlined">
      <v-card-title class="d-flex align-center py-3">
        <span class="text-subtitle-1">{{ $t('qaPreCard2Title') }}</span>

        <v-chip v-if="prechatEnabled" size="small" color="warning" variant="tonal" label class="ml-2">
          {{ $t('qaPreNotUsed') }}
        </v-chip>

        <v-spacer />
        <v-chip size="small" variant="tonal" label>{{ $t('qaPreRouteCount', { n: config.keywordRules.length }) }}</v-chip>
      </v-card-title>
      <v-divider />

      <div class="pa-4">
        <div class="d-flex align-center mb-4">
          <div>
            <div class="text-body-2 font-weight-medium">{{ $t('qaPreSendToSf') }}</div>
            <div class="text-caption text-medium-emphasis">
              {{ $t('qaPreSendToSfDesc') }}
            </div>
          </div>
          <v-spacer />
          <v-switch v-model="config.enabled" color="primary" density="compact" hide-details inset />
        </div>

        <!-- ⚠️ ขึ้นเฉพาะตอนเปิด · การเปิดเปลี่ยนสิ่งที่ Salesforce ได้รับจริง ๆ
             ไม่ใช่แค่ค่าตั้งภายใน จึงต้องเป็นแถบเต็มความกว้าง ไม่ใช่ไอคอนเล็ก ๆ -->
        <v-alert v-if="config.enabled" type="warning" variant="tonal" density="compact" class="mb-4">
          <span class="text-body-2">
            {{ $t('qaPreSfWarn') }}
          </span>
        </v-alert>

        <v-divider class="mb-4" />

        <div class="d-flex align-center flex-wrap ga-2 mb-2">
          <span class="text-body-2 font-weight-medium">{{ $t('qaPreTableTitle') }}</span>
          <v-spacer />
          <v-btn size="small" color="primary" variant="tonal" prepend-icon="mdi-plus" @click="add">
            {{ $t('qaPreAddRoute') }}
          </v-btn>
        </div>

        <!-- ⚠️ v-radio-group ครอบทั้งตาราง — นี่คือสิ่งที่บังคับว่า "ตั้งต้นได้อันเดียว"
             ถ้าเปลี่ยนเป็น checkbox รายแถว จะติ๊กได้หลายอันแล้วค่าที่ส่งขึ้น Salesforce
             จะขึ้นกับว่าแถวไหนถูกอ่านทีหลัง ซึ่งไม่มีใครเดาได้จากหน้าจอ -->
        <v-radio-group v-model="defaultRadio" hide-details class="mt-0 pt-0">
        <div class="qa-rule-scroll">
          <table class="qa-rule-table">
            <thead>
              <tr>
                <th style="width: 80px" class="text-center">
                  {{ $t('qaPreColDefault') }}
                </th>
                <th style="width: 200px">
                  {{ $t('qaPreColRoute') }}
                </th>
                <th>
                  {{ $t('qaPreColKeywords') }}
                </th>
                <th style="width: 88px" class="text-center">
                  {{ $t('qaPreColEnabled') }}
                </th>
                <th style="width: 56px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(rule, index) in config.keywordRules" :key="index"
:class="{ 'qa-rule-off': !rule.enabled }">
                <td class="text-center">
                  <!-- ⚠️ value เป็น "ลำดับแถว" ไม่ใช่ชื่อสายงาน — ชื่อยังว่างหรือซ้ำได้
                       ระหว่างที่คนกำลังพิมพ์ ถ้าผูกด้วยชื่อ ปุ่มจะกระพริบหลุดเองกลางคัน -->
                  <v-radio :value="index" :disabled="!String(rule.serviceType || '').trim()" hide-details
                    density="compact" class="d-inline-flex"
                    :title="$t('qaPreDefaultRadioTitle')" />
                </td>
                <td>
                  <v-text-field :model-value="rule.serviceType" variant="outlined" density="compact" hide-details
                    :placeholder="$t('qaPreRoutePlaceholder')" :error="(isHalfFilled(rule) && !String(rule.serviceType || '').trim()) || hasDuplicateName(rule)"
                    @update:model-value="(v) => rename(index, v)" />
                </td>
                <td>
                  <v-combobox :model-value="rule.keywords" variant="outlined" density="compact" multiple chips
                    closable-chips hide-details :placeholder="$t('qaPreKeywordsPlaceholder')"
                    :error="(isHalfFilled(rule) && !(rule.keywords || []).length) || hasDuplicateKeyword(rule)"
                    @update:model-value="(v) => setKeywords(rule, v)" />
                </td>
                <td class="text-center">
                  <v-switch v-model="rule.enabled" color="primary" density="compact" hide-details inset
                    class="d-inline-flex" />
                </td>
                <td class="qa-row-tools text-center">
                  <v-btn icon="mdi-delete-outline" size="small" variant="text" color="error" :title="$t('qaPreDeleteRow')"
                    @click="remove(index)" />
                </td>
              </tr>
              <tr v-if="config.keywordRules.length === 0">
                <td colspan="5" class="text-center text-medium-emphasis py-6">
                  {{ $t('qaPreEmpty') }}
                </td>
              </tr>

              <!-- ค่าตั้งต้นที่บันทึกไว้แต่ไม่มีแถวของตัวเอง (มาจากแถวที่ตั้งด้วย SQL ตรง ๆ)
                   ต้องโชว์ในตารางด้วย ไม่งั้นจะไม่มีอะไรติ๊กเลยทั้งที่ระบบยังส่งค่านั้นอยู่ -->
              <tr v-if="defaultIsOrphan" class="qa-rule-orphan">
                <td class="text-center">
                  <v-radio :value="ORPHAN" hide-details density="compact" class="d-inline-flex" readonly />
                </td>
                <td>
                  <span class="text-body-2">{{ defaultServiceTypeText }}</span>
                </td>
                <td colspan="3" class="text-caption text-medium-emphasis">
                  {{ $t('qaPreOrphanNote') }}
                  <v-btn size="x-small" variant="text" class="ml-1" prepend-icon="mdi-plus"
                    @click="addDefaultAsRule">{{ $t('qaPreAddAsRow') }}</v-btn>
                </td>
              </tr>

            </tbody>
          </table>
        </div>
        </v-radio-group>

        <!-- ⚠️ ต้องบอกก่อนกดบันทึก ไม่ใช่หลังกด — ตอนนี้หน้าจอติ๊กแถวแรกให้อัตโนมัติ
             และ save() จะเขียนชื่อแถวนั้นลงฐานจริง · ถ้าไม่บอก คนที่แค่เปิดหน้ามาดู
             แล้วกดบันทึกจะเปลี่ยนจาก "ตามไฟล์ตั้งค่า" เป็น "บังคับแถวแรก" โดยไม่รู้ตัว -->
        <div v-if="!defaultServiceTypeText" class="text-caption text-medium-emphasis mt-2">
          <template v-if="firstNamedRuleIndex >= 0">
            {{ $t('qaPreAutoFirstNote') }}
          </template>
          <template v-else>
            {{ $t('qaPreNoRoutesNote') }}
          </template>
        </div>

        <!-- ⚠️ รายละเอียดยาว ๆ อยู่ในนี้ที่เดียว · เดิมกระจายเป็นไอคอน ? เล็ก ๆ 5-6 จุด
             ซึ่ง (ก) มองไม่เห็นว่ามีอะไรให้อ่าน (ข) พังเงียบมาแล้วเพราะ v-icon
             ทิ้ง slot ข้างในทั้งก้อน · แบบพับเก็บนี้เป็นทรงเดียวกับแท็บ "คำแนะนำ AI" -->
        <v-expansion-panels variant="accordion" class="mt-5">
          <v-expansion-panel>
            <v-expansion-panel-title class="text-body-2">
              <v-icon start size="18" icon="mdi-help-circle-outline" />
              {{ $t('qaPreHelpTitle') }}
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <div class="text-body-2 qa-help">
                <p>
                  {{ $t('qaPreHelpName') }}
                </p>
                <p>
                  {{ $t('qaPreHelpKeywords') }}
                </p>
                <p>
                  {{ $t('qaPreHelpBroad') }}
                </p>
                <p>
                  {{ $t('qaPreHelpOrder') }}
                </p>
                <p>
                  {{ $t('qaPreHelpSwitch') }}
                </p>
                <p class="mb-0">
                  {{ $t('qaPreHelpDefault') }}
                </p>
              </div>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-card>

    <!-- ⚠️ ปุ่มที่กดไม่ได้ต้องบอกเหตุผลแบบมองไม่พลาด · เดิมเป็นตัวหนังสือแดงเล็ก ๆ
         ข้างปุ่มท้ายหน้า ซึ่งห่างจากแถวที่ผิดหลายสิบบรรทัด คนใช้เลยเห็นแค่ "ปุ่มกดไม่ติด" -->
    <v-alert v-if="saveBlockedReason" type="error" variant="tonal" density="compact" class="mb-3">
      <span class="text-body-2">{{ saveBlockedReason }}</span>
    </v-alert>

    <div class="d-flex align-center flex-wrap ga-2">
      <span v-if="updatedAtText" class="text-caption text-medium-emphasis">
        {{ $t('qaSumLastEdited', { when: updatedAtText }) }}<span v-if="updatedBy"> {{ $t('qaSumLastEditedBy', { who: updatedBy }) }}</span>
      </span>
      <v-spacer />
      <v-btn color="primary" variant="flat" :loading="saving" :disabled="!!saveBlockedReason" @click="save">
        {{ $t('qaPreSave') }}
      </v-btn>
    </div>
  </div>
</template>
<script>
/**
 * Q7 — แท็บตั้งค่า "การจัดสายงานตอนปิดบอท"
 *
 * ⚠️ บันทึกลงฐานข้อมูลจริง (cc.QaSettings section 'prechat-routing') ไม่ใช่ localStorage
 *    facade (services/qaConsole/index.js) เหลือทางเดียวคือ API จริง — Q10 ลบชั้นจำลองทั้งชั้นแล้ว
 *    ห้ามเติมทางสำรองที่เขียนลงเครื่องแล้วขึ้นว่าบันทึกสำเร็จกลับเข้ามา
 *
 * ⚠️ ค่าทั้งแท็บมีผลเฉพาะตอน Prechat.Enabled = false เท่านั้น · response พา
 *    prechatEnabled มาด้วยเพื่อขึ้นแบนเนอร์เตือน ไม่งั้นคนตั้งค่าแล้วงงว่าทำไมไม่มีผล
 *
 * ⚠️ **ห้ามส่ง creditCardKeywords กลับขึ้นไป** — ฝั่ง server ทำช่องนั้นเป็นหน้ากากของการ์ด
 *    ชื่อ "CreditCard" ใน keywordRules ไว้เพื่ออ่านค่าเก่าเท่านั้น · ถ้าหน้าจอส่งทั้งสองช่อง
 *    ค่าที่ชนะจะขึ้นกับลำดับคีย์ใน JSON ซึ่งเปลี่ยนได้ตอน refactor แล้วการ์ด CreditCard
 *    จะฟื้นหรือหายเองโดยไม่มีใครแตะ · applyValue ด้านล่างจึงหยิบเฉพาะช่องที่หน้าจอเป็นเจ้าของ
 */
import qaConsole from '@/services/qaConsole';

/**
 * ค่าของ radio สำหรับแถวพิเศษ 2 แถวท้ายตาราง
 *
 * ⚠️ ใช้เลขติดลบเพราะลำดับแถวจริงเริ่มที่ 0 · ชนกันไม่ได้แน่นอน
 */
const ORPHAN = -1;    // ค่าที่บันทึกไว้แต่ไม่มีแถวของตัวเอง (มาจาก SQL ตรง ๆ)

export default {
  name: 'QaPrechatRoutingSettings',
  emits: ['saved'],
  data() {
    return {
      config: {
        // null = ตามค่าใน appsettings · true/false = บังคับ
        botEnabled: null,
        enabled: false,
        keywordRules: [],
        // ⚠️ null ≠ '' — null = ยังไม่มีคีย์นี้ (ตกไปตาม appsettings) · '' = ตั้งใจไม่ส่ง
        defaultServiceType: null,
      },
      prechatEnabled: false,
      prechatFromAppSettings: false,
      updatedAt: null,
      updatedBy: null,
      saving: false,
    };
  },
  computed: {
    /**
     * สวิตช์แม่แบบ 3 สถานะ ↔ botEnabled (null / true / false)
     *
     * ⚠️ ต้องมี "ตามค่าในไฟล์" เป็นตัวเลือกจริง ไม่ใช่แค่ค่าเริ่มต้นที่หายไปเมื่อกด
     *    ไม่งั้นพอใครกดสำรวจแล้วบันทึก จะกลายเป็นบังคับค่าถาวรโดยไม่ตั้งใจ
     */
    botMode: {
      get() {
        if (this.config.botEnabled === null || this.config.botEnabled === undefined) return 'inherit';
        return this.config.botEnabled ? 'on' : 'off';
      },
      set(mode) {
        this.config.botEnabled = mode === 'inherit' ? null : mode === 'on';
      },
    },
    /**
     * แถวไหนถูกติ๊กเป็นสายงานตั้งต้น · ผูกกับ v-radio-group ที่ครอบทั้งตาราง
     *
     * ค่าที่เป็นไปได้:
     *   null       = ไม่มีแถวไหนตั้งชื่อเลย -> ไม่ติ๊กอะไร แล้วตกไปตาม appsettings
     *   ORPHAN(-1) = ค่าที่บันทึกไว้แต่ไม่มีแถวของตัวเอง (แถวที่ตั้งด้วย SQL ตรง ๆ)
     *   0..n-1     = ลำดับแถวในตาราง
     *
     * ⚠️ ฐานความจริงยังเป็น config.defaultServiceType (สตริง) เหมือนเดิม ตัวนี้เป็น
     *    แค่มุมมองของมัน · เก็บเป็นลำดับแถวลงฐานไม่ได้ เพราะค่าตั้งต้นเป็นค่าที่ไม่มีแถว
     *    ของตัวเองก็ได้ และลำดับแถวเปลี่ยนได้ทุกครั้งที่มีคนลบแถว
     *
     * ⚠️ ตอน get ต้องเทียบแบบ**ไม่สนตัวพิมพ์** — ค่าที่ตั้งด้วย SQL อาจสะกดคนละตัวพิมพ์
     *    กับแถว (banking vs Banking) ถ้าเทียบตรงตัวจะกลายเป็น orphan ทั้งที่มีแถวอยู่
     */
    defaultRadio: {
      get() {
        const current = this.defaultServiceTypeText;

        // ⚠️ ว่างแบบไหนก็ตกไปแถวแรกหมด — ทั้ง null (ยังไม่เคยตั้ง) และ '' (เคยล้างไว้
        //    สมัยที่หน้าจอยังมีตัวเลือก "ไม่ตั้งค่าตั้งต้น") · หน้าจอไม่มีทางสร้าง ''
        //    ได้อีกแล้ว แต่ค่าที่บันทึกไว้ก่อนหน้านี้ยังมีอยู่จริงในฐาน ถ้าไม่ดักตรงนี้
        //    ช่องจะไม่ติ๊กอะไรเลยและไม่มีคำอธิบายให้ด้วย
        if (!current) {
          return this.firstNamedRuleIndex >= 0 ? this.firstNamedRuleIndex : null;
        }

        const index = this.config.keywordRules.findIndex(
          (r) => String(r.serviceType || '').trim().toLowerCase() === current.toLowerCase(),
        );
        return index >= 0 ? index : ORPHAN;
      },
      set(value) {
        if (value === ORPHAN) return;   // แถวนั้นแสดงอย่างเดียว เลือกเข้าไม่ได้

        const rule = this.config.keywordRules[value];
        if (rule) this.config.defaultServiceType = String(rule.serviceType || '').trim();
      },
    },

    /**
     * ลำดับแถวแรกที่ตั้งชื่อสายงานแล้ว · -1 = ยังไม่มีแถวไหนตั้งชื่อเลย
     *
     * ⚠️ ต้องข้ามแถวที่ยังไม่มีชื่อ — แถวที่เพิ่งกด "เพิ่มสายงาน" ยังว่างอยู่
     *    ถ้าเอาแถว 0 ดื้อ ๆ จะได้สายงานชื่อ "" ซึ่งเลือกเป็นค่าตั้งต้นไม่ได้
     */
    firstNamedRuleIndex() {
      return this.config.keywordRules.findIndex((r) => !!String(r.serviceType || '').trim());
    },

    /**
     * ค่าคงที่ให้ template อ้างถึงได้ (ตัวเลขดิบใน markup อ่านไม่รู้เรื่อง)
     *
     * ⚠️ ต้อง expose ผ่าน computed · ค่าคงที่ระดับโมดูลไม่อยู่ใน render scope ของ Vue
     *    ถ้าลืม :value="ORPHAN" จะกลายเป็น undefined แล้วแถวนั้นติ๊กไม่ติดโดยไม่มี error
     */
    ORPHAN: () => ORPHAN,

    /** ตั้งค่าตั้งต้นไว้เป็นชื่อที่ไม่มีแถวของตัวเองในตาราง */
    defaultIsOrphan() {
      const name = this.defaultServiceTypeText;
      if (!name) return false;
      return !this.config.keywordRules.some(
        (r) => String(r.serviceType || '').trim().toLowerCase() === name.toLowerCase(),
      );
    },

    /** สายงานตั้งต้นที่มีผลจริง เป็นข้อความ · '' = ไม่ตั้ง (null และ '' คืนค่าเท่ากัน) */
    defaultServiceTypeText() {
      return String(this.config.defaultServiceType || '').trim();
    },

    /**
     * ชื่อสายงานที่ซ้ำกัน (ไม่สนตัวพิมพ์) — คืนเป็นตัวพิมพ์เล็กไว้เทียบ
     *
     * ⚠️ ต้องเตือน เพราะฝั่ง server <b>รวมแถวชื่อซ้ำเข้าด้วยกัน</b>ตอนบันทึก
     *    (Normalized() → GroupBy ServiceType) · ถ้าไม่บอก คนกรอก 2 แถวแล้วกดบันทึก
     *    จะเห็นเหลือแถวเดียวโดยไม่มีอะไรอธิบายว่าอีกแถวหายไปไหน
     */
    duplicateNames() {
      const count = new Map();
      for (const rule of this.config.keywordRules) {
        const name = String(rule.serviceType || '').trim().toLowerCase();
        if (!name) continue;
        count.set(name, (count.get(name) || 0) + 1);
      }
      return [...count.entries()].filter(([, n]) => n > 1).map(([name]) => name);
    },

    /**
     * คำที่โผล่ในมากกว่า 1 แถว
     *
     * ⚠️ ระบบจับ "แถวแรกที่เจอ" (MatchRule คืนแถวแรก) · คำที่ซ้ำข้ามแถวแปลว่า
     *    แถวล่าง<b>ไม่มีวันถูกใช้</b>ด้วยคำนั้นเลย — และตอนนี้หน้าจอไม่มีปุ่มเลื่อนลำดับแล้ว
     *    คนตั้งค่าจึงคุมไม่ได้ว่าใครชนะ ถือเป็นความผิดพลาดเสมอ ไม่ใช่ทางเลือก
     */
    duplicateKeywords() {
      const owners = new Map();
      this.config.keywordRules.forEach((rule, index) => {
        // ⚠️ แถวที่ปิดอยู่ไม่ไปแย่งจับใคร จึงไม่นับว่าซ้ำ · ไม่งั้นคนปิดแถวไว้เพื่อ
        //    เลี่ยงการชนกันพอดี จะยังโดนบล็อกไม่ให้บันทึกอยู่ดี
        if (!rule.enabled) return;
        for (const raw of rule.keywords || []) {
          const word = String(raw || '').trim().toLowerCase();
          if (!word) continue;
          if (!owners.has(word)) owners.set(word, new Set());
          owners.get(word).add(index);
        }
      });
      return [...owners.entries()].filter(([, rows]) => rows.size > 1).map(([word]) => word);
    },

    /**
     * เหตุผลที่กดบันทึกไม่ได้ · '' = บันทึกได้
     *
     * ⚠️ **จุดเดียว**ที่รวมเงื่อนไขทั้งหมด — ปุ่มใช้ตัวนี้ disable และหน้าจอใช้ตัวนี้
     *    ขึ้นข้อความ · ถ้าแยกกันเมื่อไหร่ จะกลับไปเป็นเคส "ปุ่มกดได้แต่ save() return
     *    ทิ้งเงียบ ๆ" ซึ่งเจอมาแล้วทั้งสองหน้า
     */
    saveBlockedReason() {
      if (this.brokenRows.length) {
        return this.$t('qaPreBrokenRows', { rows: this.brokenRows.join(', ') });
      }
      if (this.duplicateNames.length) {
        return this.$t('qaPreDupNames', { names: this.duplicateNames.join(', ') });
      }
      if (this.duplicateKeywords.length) {
        return this.$t('qaPreDupKeywords', { words: this.duplicateKeywords.join(', ') });
      }
      return '';
    },

    /**
     * เลขแถว (เริ่มที่ 1) ที่กรอกไม่ครบ — เอาไว้บอกคนใช้ว่าติดตรงไหน
     *
     * ⚠️ ต้องบอก**เลขแถว** ไม่ใช่แค่จำนวน · ตารางยาว ๆ กับข้อความ "มี 2 แถวกรอกไม่ครบ"
     *    แปลว่าคนต้องไล่หาเองทีละแถว ซึ่งเป็นที่มาของอาการ "ปุ่มบันทึกกดไม่ติด"
     */
    brokenRows() {
      return this.config.keywordRules
        .map((r, i) => (this.isHalfFilled(r) ? i + 1 : 0))
        .filter(Boolean);
    },

    /**
     * แถวที่กรอกไป**ข้างเดียว** — ปุ่มบันทึกใช้ตัวนี้ปิดตัวเอง
     *
     * ⚠️ ต้องเป็นเงื่อนไขเดียวกับกรอบแดง (isHalfFilled) เป๊ะ ๆ · เดิมตัวนี้นับแถวที่ว่าง
     *    ทั้งแถวด้วย แต่กรอบแดงไม่ขึ้นให้ → แถวที่เพิ่งกด "เพิ่มสายงาน" แล้วยังไม่กรอก
     *    ทำให้ปุ่มบันทึกดับโดยไม่มีอะไรบนหน้าจอบอกว่าติดตรงไหน (เจอตอนเทสจริง 7 ก.ย. 2026)
     *
     *    แถวว่างทั้งแถวไม่ใช่ความผิดพลาด — มันคือ "ยังไม่ได้กรอก" · save() ตัดทิ้งให้
     *    แล้วบอกว่าตัดไปกี่แถว
     */
    updatedAtText() {
      if (!this.updatedAt) return '';
      try {
        return new Date(this.updatedAt).toLocaleString('th-TH');
      } catch {
        return this.updatedAt;
      }
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    // ── ตารางสายงาน / คำที่จับ ──────────────────────────────────────────
    /**
     * ค่าตั้งต้นที่ยังไม่มีแถว -> สร้างแถวให้ (ยังไม่มีคำ ต้องไปพิมพ์เองในตาราง)
     *
     * ⚠️ ไม่ไปแตะ config.defaultServiceType — ชื่อเหมือนเดิมเป๊ะ พอมีแถวแล้ว
     *    defaultIsOrphan จะกลายเป็น false เอง แล้วช่องเลือกก็ชี้แถวใหม่ให้ทันที
     */
    addDefaultAsRule() {
      const name = this.defaultServiceTypeText;
      if (!name) return;
      this.config.keywordRules.push({ serviceType: name, keywords: [], enabled: true });
    },
    /** แถวนี้ชื่อซ้ำกับแถวอื่นไหม — ใช้ตัดสินกรอบแดงของช่องชื่อ */
    hasDuplicateName(rule) {
      const name = String(rule.serviceType || '').trim().toLowerCase();
      return !!name && this.duplicateNames.includes(name);
    },

    /** แถวนี้มีคำที่ไปซ้ำกับแถวอื่นไหม — ใช้ตัดสินกรอบแดงของช่องคำ */
    hasDuplicateKeyword(rule) {
      return (rule.keywords || []).some((k) =>
        this.duplicateKeywords.includes(String(k || '').trim().toLowerCase()),
      );
    },

    /**
     * รับคำที่พิมพ์เข้ามาแล้วทำให้ใช้ได้จริงก่อนเก็บ
     *
     * ⚠️ v-combobox เอา "ทุกอย่างที่พิมพ์ก่อนกด Enter" มาเป็น chip เดียวดิบ ๆ ·
     *    คนที่พิมพ์ ",สวัสดี, สวัสดี," รวดเดียวจะได้ chip เดียวที่หน้าตาเหมือนคำ
     *    แต่ระบบเอาไปเทียบแบบตรงตัวทั้งสตริง = ไม่มีวัน match และไม่มี error ให้เห็น
     *
     * ⚠️ **ยุบช่องว่างซ้ำ แต่ห้ามลบช่องว่างทิ้ง** — "credit card" เป็นคำที่ถูกต้อง
     *    สิ่งที่ต้องกันคือ "สวัสดี  ครับ" ที่เว้นสองทีโดยไม่ตั้งใจ
     *
     * ⚠️ ตัดซ้ำแบบไม่สนตัวพิมพ์ให้ตรงกับฝั่ง server (Normalized) — ไม่งั้นหน้าจอโชว์ 2 chip
     *    แล้วหายไปหนึ่งอันหลังบันทึกโดยไม่มีอะไรอธิบาย
     */
    setKeywords(rule, value) {
      const out = [];

      for (const raw of value || []) {
        // คั่นด้วย , หรือขึ้นบรรทัดใหม่ (เผื่อคนวางมาจากไฟล์/Excel)
        for (const part of String(raw ?? '').split(/[,\r\n]+/)) {
          const word = part.trim().replace(/\s+/g, ' ');
          if (!word) continue;
          if (out.some((w) => w.toLowerCase() === word.toLowerCase())) continue;
          out.push(word);
        }
      }

      rule.keywords = out;
    },

    /** แถวว่างทั้งแถว — ยังไม่ได้กรอก ไม่ใช่ความผิดพลาด · save() ตัดทิ้งให้ */
    isEmptyRule(rule) {
      return !String(rule.serviceType || '').trim() && !(rule.keywords || []).length;
    },

    /**
     * แถวนี้กรอกไปครึ่งเดียวหรือยัง — ใช้ตัดสินว่าจะขึ้นกรอบแดงไหม
     *
     * ⚠️ แถวที่เพิ่งกด "เพิ่มสายงาน" ว่างทั้งสองช่องโดยธรรมชาติ · ถ้าขึ้นแดงทันที
     *    หน้าจอจะดูเหมือนพัง ทั้งที่คนยังไม่ได้ทำอะไรผิดเลย · แดงเมื่อกรอกไปข้างเดียว
     *    (ซึ่งเป็นความผิดพลาดจริง) และ save() ยังกันแถวว่างให้อยู่แล้วอีกชั้น
     */
    isHalfFilled(rule) {
      const hasName = !!String(rule.serviceType || '').trim();
      const hasWords = !!(rule.keywords || []).length;
      return hasName !== hasWords;
    },
    add() {
      this.config.keywordRules.push({ serviceType: '', keywords: [], enabled: true });
    },

    /**
     * ⚠️ ลบแถวที่เป็นสายงานตั้งต้นอยู่ ต้องล้างค่าตั้งต้นตามไปด้วย
     *    ไม่งั้นค่าจะค้างชี้ไปสายงานที่ไม่มีแถวแล้ว — ยังส่งขึ้น Salesforce ได้อยู่
     *    (สายงานตั้งต้นเป็นข้อความอิสระ) แต่ในตารางจะไม่เหลืออะไรให้เห็นเลย
     */
    remove(index) {
      const name = String(this.config.keywordRules[index].serviceType || '').trim();
      const wasDefault = !!name && name.toLowerCase() === this.defaultServiceTypeText.toLowerCase();
      this.config.keywordRules.splice(index, 1);

      // ⚠️ ล้างค่าตั้งต้นเฉพาะตอน**ไม่เหลือแถวชื่อนี้อีกแล้ว** · ชื่อซ้ำกันเกิดได้จริง
      //    ระหว่างที่คนกำลังพิมพ์ (หน้าจอบล็อกแค่ตอนกดบันทึก) ถ้าล้างทันทีโดยไม่ดู
      //    แถวที่เหลือ การลบใบซ้ำทิ้งจะพาค่าตั้งต้นหายไปด้วยทั้งที่ยังมีแถวชื่อนั้นอยู่
      const stillExists = this.config.keywordRules.some(
        (r) => String(r.serviceType || '').trim().toLowerCase() === name.toLowerCase(),
      );
      if (wasDefault && !stillExists) this.config.defaultServiceType = '';
    },

    /**
     * เปลี่ยนชื่อสายงาน · ถ้าแถวนั้นถูกเลือกเป็นสายงานตั้งต้นอยู่ ต้องลากค่าตั้งต้นตามไปด้วย
     *
     * ⚠️ ไม่งั้นการเปลี่ยนชื่อจะทำให้ค่าตั้งต้นชี้ไปยังสายงานที่ไม่มีแถวแล้วเงียบ ๆ
     *    ซึ่งยังส่งขึ้น Salesforce ได้อยู่ (ค่าตั้งต้นเป็นข้อความอิสระ) แต่ไม่ใช่สิ่งที่คนตั้งใจ
     */
    rename(index, value) {
      const before = String(this.config.keywordRules[index].serviceType || '').trim();
      const wasDefault = !!before && before.toLowerCase() === this.defaultServiceTypeText.toLowerCase();
      this.config.keywordRules[index].serviceType = value;
      if (wasDefault) this.config.defaultServiceType = String(value || '').trim();
    },

    // ── โหลด / บันทึก ───────────────────────────────────────────────────
    applyValue(value) {
      if (!value) return;
      this.config = {
        botEnabled: value.botEnabled ?? null,
        enabled: !!value.enabled,
        // ⚠️ ?? null ไม่ใช่ ?? '' — แถวที่ไม่มีคีย์นี้ต้องคงความหมาย "ตาม appsettings" ไว้
        //    ถ้าบีบเป็น '' ทุกครั้งที่เปิดหน้าแล้วกดบันทึก จะกลายเป็น "ตั้งใจไม่ส่ง" เอง
        defaultServiceType: value.defaultServiceType ?? null,
        keywordRules: (value.keywordRules || []).map((r) => ({
          serviceType: r.serviceType || '',
          keywords: Array.isArray(r.keywords) ? [...r.keywords] : [],
          // ⚠️ !== false ไม่ใช่ ?? true — แถวที่บันทึกไว้ก่อนมีช่องนี้ไม่มีคีย์ enabled
          //    ต้องถือว่า "เปิดอยู่" เหมือนเดิม ไม่ใช่ปิดยกแผงทันทีที่ deploy
          enabled: r.enabled !== false,
        })),
      };
    },
    applyMeta(res) {
      this.prechatEnabled = !!(res && res.prechatEnabled);
      this.prechatFromAppSettings = !!(res && res.prechatFromAppSettings);
      this.updatedAt = res ? res.updatedAt : null;
      this.updatedBy = res ? res.updatedBy : null;
    },

    async load() {
      try {
        const res = await qaConsole.getPrechatRouting();
        this.applyValue(res && res.value);
        this.applyMeta(res);
      } catch (err) {
        this.$emit('saved', { ok: false, message: this.$t('qaEvalLoadFailed', { msg: err.message }) });
      }
    },

    async save() {
      // ⚠️ **เช็คก่อน แก้ทีหลัง** — เดิมตัดแถวว่างทิ้งไปก่อนแล้วค่อย return เพราะเจอแถว
      //    ที่กรอกครึ่งเดียว = ไปแก้ข้อมูลของคนใช้ทั้งที่บันทึกไม่สำเร็จสักนิด
      if (this.saveBlockedReason) {
        this.$emit('saved', { ok: false, message: this.saveBlockedReason });
        return;
      }

      // แถวที่ว่างทั้งแถว = "ยังไม่ได้กรอก" ไม่ใช่ความผิดพลาด — ตัดทิ้งให้แล้วบอกว่าตัดไปกี่แถว
      //
      // ⚠️ ตัดที่นี่ไม่ใช่ปล่อยให้ server ตัด · Normalized() ฝั่งโน้นตัดอยู่แล้วจริง
      //    แต่ตัดเงียบ ๆ = คนกดบันทึกแล้วเห็นแถวหายไปเฉย ๆ โดยไม่มีอะไรอธิบาย
      const dropped = this.config.keywordRules.filter((r) => this.isEmptyRule(r)).length;
      if (dropped) {
        this.config.keywordRules = this.config.keywordRules.filter((r) => !this.isEmptyRule(r));
      }

      // ⚠️ หน้าจอติ๊กแถวแรกให้ตอนยังไม่เคยเลือกเอง · ต้องเขียนค่านั้นลงฐานจริงด้วย
      //    ไม่งั้นสิ่งที่เห็นบนหน้าจอกับสิ่งที่ระบบใช้จะไม่ตรงกัน (หน้าจอติ๊กแถวแรก
      //    แต่ระบบยังใช้ค่าจาก appsettings) ซึ่งเป็นอาการที่หาสาเหตุยากที่สุดแบบหนึ่ง
      if (!this.defaultServiceTypeText && this.firstNamedRuleIndex >= 0) {
        this.config.defaultServiceType =
          String(this.config.keywordRules[this.firstNamedRuleIndex].serviceType || '').trim();
      }

      this.saving = true;
      try {
        const sent = this.config.keywordRules.length;
        const res = await qaConsole.savePrechatRouting(this.config);

        // ⚠️ **ด่านกันข้อมูลหายเงียบ ๆ ตอน backend เก่ากว่าหน้าเว็บ**
        //
        //    backend ที่ยังไม่มีฟิลด์ keywordRules จะทิ้งสิ่งที่เราส่งไปทั้งก้อน แล้วตอบกลับมา
        //    โดยไม่มีคีย์นั้นเลย · ถ้าเอา response มาทับหน้าจอตามปกติ ตารางจะกลายเป็นว่าง
        //    ทันทีหลังกดบันทึก = คนกรอกมาทั้งหน้าเห็นของหายไปต่อหน้า โดยขึ้นว่า "บันทึกแล้ว"
        //    (เจอตอนเทสจริง 7 ก.ย. 2026 — หน้าเว็บใหม่ชี้ backend ที่ยังไม่ได้ deploy)
        //
        //    ตรวจที่ "คีย์หายไปทั้งอัน" ไม่ใช่ "ลิสต์ว่าง" — ลิสต์ว่างเป็นผลลัพธ์ที่ถูกต้อง
        //    ได้จริงเมื่อคนลบทุกแถวทิ้งเอง
        //
        //    ⚠️ ข้อความที่ขึ้นให้ผู้ใช้เห็นตั้งใจไม่พูดถึง deploy/เวอร์ชัน — หน้านี้ผู้ใช้งาน
        //       ทั่วไปเปิดได้ · เหตุผลจริงอยู่ในคอมเมนต์นี้ให้คนแก้โค้ดอ่านแทน
        const returned = res && res.value ? res.value.keywordRules : undefined;
        if (sent > 0 && !Array.isArray(returned)) {
          this.$emit('saved', {
            ok: false,
            message: this.$t('qaPreSaveFailedKeep'),
          });
          return;
        }

        // ฝั่ง server normalize ให้แล้ว (ตัดคำว่าง ตัดซ้ำ trim) — เอาค่าที่บันทึกจริงกลับมาแสดง
        // ไม่งั้นหน้าจอจะโชว์สิ่งที่คนกรอก แต่ระบบใช้อีกค่าหนึ่ง
        this.applyValue(res && res.value);
        this.applyMeta(res);
        this.$emit('saved', {
          ok: true,
          message: dropped ? this.$t('qaPreSavedDropped', { n: dropped }) : this.$t('qaPreSaved'),
        });
      } catch (err) {
        this.$emit('saved', { ok: false, message: this.$t('qaSetSaveFailed', { msg: err.message }) });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
/* ⚠️ ทรงตารางเดียวกับ QaFeedbackReasonSettings.vue แต่ **มีเส้นจริง** —
   ตารางที่ไม่มีขอบเลยทำให้ช่องกรอกดูลอยอยู่กลางอากาศ แยกไม่ออกว่าอะไรเป็นแถวเดียวกัน
   โดยเฉพาะตอนมีแถวเดียว ซึ่งเป็นสภาพที่คนเห็นบ่อยที่สุด (เพิ่งกดเพิ่มสายงานแรก) */
.qa-rule-scroll {
  overflow-x: auto;
  border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 4px;
}

.qa-rule-table {
  width: 100%;
  min-width: 680px;
  border-collapse: collapse;
}

.qa-rule-table thead th {
  text-align: left;
  font-size: 0.75rem;
  font-weight: 600;
  opacity: 0.75;
  padding: 10px 12px;
  white-space: nowrap;
  background: rgba(var(--v-theme-on-surface), 0.04);
  border-bottom: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.qa-rule-table tbody td {
  padding: 10px 12px;
  vertical-align: middle;
  border-bottom: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

/* แถวสุดท้ายไม่ต้องมีเส้นล่าง — กล่องครอบมีขอบของตัวเองอยู่แล้ว จะกลายเป็นเส้นคู่ */
.qa-rule-table tbody tr:last-child td {
  border-bottom: none;
}

/* คอลัมน์ลูกศรกับถังขยะเป็นเครื่องมือ ไม่ใช่ข้อมูล — ทำให้จางลงจนกว่าจะชี้ที่แถว
   ไม่งั้นสายตาไปตกที่ไอคอนก่อนตัวหนังสือ ทั้งที่ของสำคัญคือชื่อสายงานกับคำ */
.qa-rule-table tbody tr .qa-row-tools {
  opacity: 0.45;
  transition: opacity 0.15s;
}

.qa-rule-table tbody tr:hover .qa-row-tools,
.qa-rule-table tbody tr:focus-within .qa-row-tools {
  opacity: 1;
}

/* 2 แถวท้ายตารางไม่ใช่สายงานจริง — ทำพื้นหลังจาง ๆ ให้แยกออกจากแถวข้อมูล
   ไม่งั้นคนจะนึกว่าเป็นสายงานอีกใบที่ตั้งชื่อแปลก ๆ */
.qa-rule-table tbody tr.qa-rule-none td,
.qa-rule-table tbody tr.qa-rule-orphan td {
  background: rgba(var(--v-theme-on-surface), 0.03);
}

/* แถวที่ปิดอยู่ต้องดูต่างจากที่เปิด ไม่งั้นตารางยาว ๆ จะแยกไม่ออกว่าอะไรมีผลจริง
   (ทรงเดียวกับ .qa-reason-off ในแท็บ "เหตุผลของการให้คะแนน") */
.qa-rule-off {
  opacity: 0.5;
}

/* กล่องคำอธิบายแบบพับเก็บ — ย่อหน้าติดกันเกินไปจะอ่านยากกว่าไม่มีเลย */
.qa-help p {
  margin-bottom: 10px;
  line-height: 1.7;
}
</style>
